export const translations = {
  en: {
    nav: {
      brand: "Eduard Toader",
      about: "About",
      experience: "Experience",
      competencies: "Expertise",
      contact: "Contact",
      cta: "Get in Touch",
    },
    hero: {
      overline: "Eduard Toader — Strategic Development Leadership",
      lines: ["Real Estate.", "Renewable Energy.", "Commercial Oversight."],
      sub: "I lead complex real estate and renewable energy ventures from land acquisition to commercial delivery — with discipline, transparency and measurable results.",
      primaryCta: "View My Work",
      secondaryCta: "Contact Me",
      stats: [
        { value: "30+", label: "Years of Development" },
        { value: "248 ha", label: "Solar & BESS Parks Secured" },
        { value: "6+", label: "BESS Plots Secured" },
      ],
      portraitAlt: "Portrait of Eduard Toader",
      visualCaption: "Renewable Development",
      scroll: "Scroll",
    },
    marquee: [
      "Real Estate Development",
      "Renewable Energy",
      "Land Acquisition",
      "Commercial Project Oversight",
      "Infrastructure Leadership",
    ],
    about: {
      label: "About",
      heading: "A career built where buildings rise and energy turns green.",
      p1: "For over three decades I have worked at the intersection of real estate development and energy — from expanding retail networks for Shell, Billa and Kaufland to securing land for solar, wind and battery storage projects across Romania.",
      p2: "My philosophy is simple: rigorous due diligence, honest communication with every stakeholder, and an obsession with delivery. A project is only successful when it creates lasting value for investors, communities and the environment alike.",
      pillars: [
        { title: "Discipline", desc: "Every milestone measured, every budget defended." },
        { title: "Integrity", desc: "Transparent governance with partners and regulators." },
        { title: "Long-term Value", desc: "Assets and energy infrastructure built to endure." },
      ],
    },
    experience: {
      label: "Experience",
      heading: "Roles that shaped skylines and powered grids.",
      note: "Full career history on LinkedIn — 30+ years across energy and commercial real estate.",
      roles: [
        {
          title: "Senior Project Manager",
          company: "Qair Renewables Romania",
          period: "2023 — Present",
          location: "Bucharest",
          achievements: [
            "Land acquisition for wind, solar and BESS projects across Romania",
            "Secured 6+ BESS plots in 18 months, with 2 more in progress across multiple counties",
            "Negotiated and closed a 64 ha solar + BESS park in Prahova (direct 110kV injection) and a 184 ha solar park in Mehedinți (220kV + BESS)",
            "Facilitated the land agreement for a 40MW wind park",
          ],
        },
        {
          title: "Senior Land Project Manager",
          company: "Amromco Energy",
          period: "2012 — 2016",
          location: "Ploiești",
          achievements: [
            "Owned land rental and acquisition across oil-field concession areas",
            "Secured all authorisations, approvals and permits for Oil & Gas field operations, ensuring full regulatory compliance",
            "Coordinated cadastre, land-register works and contracting with landowners, authorities and subcontractors",
          ],
        },
        {
          title: "Project Manager, Wind Farms",
          company: "WPD Romania",
          period: "2009 — 2011",
          location: "Galați",
          achievements: [
            "First WPD employee in Romania — established the local entity, budgeting and development processes",
            "Secured land, grid connections and permits for wind projects including Gropeni, Lacu Sărat and Bărăganul (Brăila)",
            "Delivered fully permitted project sites ready for contractors",
          ],
        },
        {
          title: "Development Area Manager",
          company: "Kaufland Romania",
          period: "2007 — 2008",
          location: "Romania",
          achievements: [
            "Led area development and site acquisition for retail network expansion",
            "Managed feasibility, negotiation and permitting for new store locations",
          ],
        },
      ],
      earlier: {
        label: "Earlier Career — 1993–2007",
        text: "Development and network-expansion roles at Shell Romania, Amoco Romania, Connex (Vodafone) real-estate subcontracting, Billa Romania and Plus Discount Romania, followed by development consultancy for Trigranit Romania and GFS Romania.",
      },
    },
    competencies: {
      label: "Expertise",
      heading: "Core competencies, engineered for delivery.",
      cards: [
        { title: "Land Acquisition & Securing", desc: "Wind, solar and BESS site sourcing, legality verification, protected-area and grid-capacity screening." },
        { title: "Permitting & Regulatory Affairs", desc: "Authorisations, approvals, cadastre and land-register works — full compliance with authorities." },
        { title: "Commercial Real Estate Development", desc: "Retail network expansion, site selection, negotiation and delivery for international chains." },
        { title: "Stakeholder & Authority Relations", desc: "Landowners, local authorities, subcontractors and boards — aligned around one delivery plan." },
        { title: "Contract Negotiation & Closing", desc: "Land lease and purchase contracts, grid-connection agreements and JV structures." },
      ],
      tagsLabel: "Also fluent in",
      tags: ["Wind & Solar Development", "BESS", "Due Diligence", "Grid Connection", "Cadastre", "Oil & Gas Permitting", "Retail Expansion"],
    },
    contact: {
      label: "Contact",
      heading: "Let's build something enduring.",
      sub: "Tell me about your project, partnership or opportunity — I reply within two business days.",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        type: "Inquiry Type",
        message: "Tell me about your inquiry",
        types: ["Real Estate Development", "Renewable Energy", "Commercial Oversight", "Partnership / Investment", "Other"],
        submit: "Send Inquiry",
        sending: "Sending…",
      },
      toastSuccess: "Inquiry sent — thank you. I'll get back to you shortly.",
      toastError: "Something went wrong. Please try again or email me directly.",
      card: {
        emailLabel: "Email",
        email: "eduard.toader@gmail.com",
        phoneLabel: "Phone",
        phone: "+40 723 772 210",
        locationLabel: "Based in",
        location: "Ploiești, Romania",
      },
    },
    footer: {
      rights: "© 2026 Eduard Toader. All rights reserved.",
      tagline: "Real estate & renewable energy development leadership.",
    },
  },
  ro: {
    nav: {
      brand: "Eduard Toader",
      about: "Despre",
      experience: "Experiență",
      competencies: "Expertiză",
      contact: "Contact",
      cta: "Contactează-mă",
    },
    hero: {
      overline: "Eduard Toader — Leadership Strategic în Dezvoltare",
      lines: ["Real Estate.", "Energie Regenerabilă.", "Coordonare Comercială."],
      sub: "Conduc proiecte complexe de real estate și energie regenerabilă, de la achiziția terenului până la livrarea comercială — cu disciplină, transparență și rezultate măsurabile.",
      primaryCta: "Vezi Portofoliul",
      secondaryCta: "Contactează-mă",
      stats: [
        { value: "30+", label: "Ani de Dezvoltare" },
        { value: "248 ha", label: "Parcuri Solare & BESS Securizate" },
        { value: "6+", label: "Amplasamente BESS Securizate" },
      ],
      portraitAlt: "Portret Eduard Toader",
      visualCaption: "Dezvoltare Regenerabilă",
      scroll: "Derulează",
    },
    marquee: [
      "Dezvoltare Imobiliară",
      "Energie Regenerabilă",
      "Achiziție Terenuri",
      "Coordonare Proiecte Comerciale",
      "Leadership în Infrastructură",
    ],
    about: {
      label: "Despre",
      heading: "O carieră construită acolo unde se ridică clădiri și energia devine verde.",
      p1: "De peste trei decenii lucrez la intersecția dintre dezvoltarea imobiliară și energie — de la extinderea rețelelor retail pentru Shell, Billa și Kaufland până la securizarea terenurilor pentru proiecte solare, eoliene și de stocare (BESS) în toată România.",
      p2: "Filosofia mea este simplă: due diligence riguros, comunicare onestă cu fiecare stakeholder și obsesia livrării. Un proiect este reușit doar atunci când creează valoare de durată pentru investitori, comunități și mediu.",
      pillars: [
        { title: "Disciplină", desc: "Fiecare etapă măsurată, fiecare buget apărat." },
        { title: "Integritate", desc: "Guvernanță transparentă cu parteneri și autorități." },
        { title: "Valoare pe Termen Lung", desc: "Active și infrastructură energetică construite să dureze." },
      ],
    },
    experience: {
      label: "Experiență",
      heading: "Roluri care au modelat orizonturi și au alimentat rețele.",
      note: "Istoricul complet al carierei pe LinkedIn — peste 30 de ani în energie și real estate comercial.",
      roles: [
        {
          title: "Manager Senior de Proiect",
          company: "Qair Renewables Romania",
          period: "2023 — Prezent",
          location: "București",
          achievements: [
            "Achiziție de terenuri pentru proiecte eoliene, solare și BESS în toată România",
            "Peste 6 amplasamente BESS securizate în 18 luni, cu încă 2 în derulare, în mai multe județe",
            "Contracte negociate și încheiate pentru un parc solar + BESS de 64 ha în Prahova (racordare directă 110kV) și un parc solar de 184 ha în Mehedinți (220kV + BESS)",
            "Acord de teren facilitat pentru un parc eolian de 40MW",
          ],
        },
        {
          title: "Manager Senior Proiecte Terenuri",
          company: "Amromco Energy",
          period: "2012 — 2016",
          location: "Ploiești",
          achievements: [
            "Responsabil pentru închirierea și achiziția terenurilor în perimetrele concesionate petroliere",
            "Toate autorizațiile, avizele și aprobările pentru operațiunile Oil & Gas, cu conformitate deplină la reglementările în vigoare",
            "Coordonarea lucrărilor de cadastru și carte funciară și a contractării cu proprietari, autorități și subcontractanți",
          ],
        },
        {
          title: "Manager de Proiect, Parcuri Eoliene",
          company: "WPD Romania",
          period: "2009 — 2011",
          location: "Galați",
          achievements: [
            "Primul angajat WPD în România — am înființat entitatea locală, bugetarea și procesele de dezvoltare",
            "Terenuri, racordări la rețea și avize securizate pentru proiectele eoliene Gropeni, Lacu Sărat și Bărăganul (Brăila)",
            "Amplasamente complet avizate, predate antreprenorilor",
          ],
        },
        {
          title: "Manager Dezvoltare Zonală",
          company: "Kaufland Romania",
          period: "2007 — 2008",
          location: "România",
          achievements: [
            "Conducerea dezvoltării zonale și a achiziției de amplasamente pentru extinderea rețelei retail",
            "Gestionarea fezabilității, negocierii și avizării pentru noi locații de magazine",
          ],
        },
      ],
      earlier: {
        label: "Începuturile Carierei — 1993–2007",
        text: "Roluri de dezvoltare și extindere de rețea la Shell Romania, Amoco Romania, subcontractare real-estate pentru Connex (Vodafone), Billa Romania și Plus Discount Romania, urmate de consultanță de dezvoltare pentru Trigranit Romania și GFS Romania.",
      },
    },
    competencies: {
      label: "Expertiză",
      heading: "Competențe de bază, gândite pentru livrare.",
      cards: [
        { title: "Achiziție & Securizare Terenuri", desc: "Identificarea amplasamentelor eoliene, solare și BESS, verificarea legalității, ariilor protejate și capacității rețelei." },
        { title: "Avizare & Relații cu Autoritățile", desc: "Autorizații, aprobări, cadastru și carte funciară — conformitate deplină cu autoritățile." },
        { title: "Dezvoltare Real Estate Comercial", desc: "Extindere de rețele retail, selecția amplasamentelor, negociere și livrare pentru lanțuri internaționale." },
        { title: "Relații cu Stakeholderi & Autorități", desc: "Proprietari, autorități locale, subcontractanți și board-uri — aliniați în jurul aceluiași plan de livrare." },
        { title: "Negociere & Închidere Contracte", desc: "Contracte de închiriere și vânzare-cumpărare terenuri, acorduri de racordare și structuri JV." },
      ],
      tagsLabel: "De asemenea",
      tags: ["Dezvoltare Eolian & Solar", "BESS", "Due Diligence", "Racordare Rețea", "Cadastru", "Avizare Oil & Gas", "Extindere Retail"],
    },
    contact: {
      label: "Contact",
      heading: "Hai să construim ceva de durată.",
      sub: "Spune-mi despre proiectul, parteneriatul sau oportunitatea ta — răspund în maximum două zile lucrătoare.",
      form: {
        name: "Nume Complet",
        email: "Adresă de Email",
        phone: "Număr de Telefon",
        type: "Tipul Solicitării",
        message: "Detalii despre solicitare",
        types: ["Dezvoltare Imobiliară", "Energie Regenerabilă", "Coordonare Comercială", "Parteneriat / Investiție", "Altele"],
        submit: "Trimite Solicitarea",
        sending: "Se trimite…",
      },
      toastSuccess: "Solicitarea a fost trimisă — mulțumesc. Revin curând cu un răspuns.",
      toastError: "Ceva nu a funcționat. Încearcă din nou sau scrie-mi direct pe email.",
      card: {
        emailLabel: "Email",
        email: "eduard.toader@gmail.com",
        phoneLabel: "Telefon",
        phone: "+40 723 772 210",
        locationLabel: "Bazat în",
        location: "Ploiești, România",
      },
    },
    footer: {
      rights: "© 2026 Eduard Toader. Toate drepturile rezervate.",
      tagline: "Leadership în dezvoltare imobiliară și energie regenerabilă.",
    },
  },
};
